<template>
  <div class="card" :class="{sm}" @click="check">
    <div class="image-wrap" :class="{bordered: !card.thumbnail}">
      <slot name="image">
        <img-lazy :src="card.thumbnail | thumbnail(80, 80)" class="image"/>
      </slot>
      <van-icon name="checked" class="checker" v-if="selectable && card.checked"/>
    </div>
    <div class="card-name">
      <slot name="name">{{ card.name }}</slot>
    </div>
  </div>
</template>

<script>
  import ImgLazy from '@/components/ImgLazy'
  import { Icon } from 'vant'

  export default {
    name: 'card-jewel',
    components: { ImgLazy, [Icon.name]: Icon},
    props: {
      card: {
        type: Object,
        default: () => {
          return {}
        }
      },
      selectable: {
        type: Boolean,
        default: false
      },
      sm: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      check() {
        if (!this.selectable) return

        this.card.checked = !this.card.checked
      }
    }
  }
</script>

<style lang="less" scoped>
  .card {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    padding: 12px 10px;
  }

  .image-wrap {
    position: relative;
    width: 1.36rem;
    height: 1.36rem;
    border-radius: 50%;
  }

  .image-wrap.bordered {
    border: 1px solid #EEE;
  }

  .card.sm .image-wrap {
    width: 1.12rem;
    height: 1.12rem;
  }

  .image {
    width: 100%;
    height: 100%;
  }

  .checker {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 0.56rem;
    height: 0.56rem;
    font-size: 0.56rem;
    line-height: 1;
    color: #e9aea8;
  }

  .card-name {
    font-size: 13px;
    line-height: 1;
    text-align: center;
    margin-top: 10px;
    color: #656565;
  }
</style>